export default {
  '请求': {
    '加载中': 'Loading',
    '请求失败': 'Request failed',
    '登录已过期': 'Session expired',
    '网络连接失败': 'Network connection failed',
    '请重新登录': 'Please log in again',
    '没有权限访问': 'Access denied',
    '请求的资源不存在': 'Resource not found',
    '服务器错误': 'Server error',
    '网络错误': 'Network error',
    '刷新成功': 'Refreshed',
    '获取中': 'Loading...',
    '账号下线': 'Account offline',
    '功能已禁用': 'Feature disabled',
  },
  '导航': {
    '首页': 'Home',
    '选妃': 'Choose',
    '认证': 'Verify',
    '影院': 'Video',
    '个人': 'Mine',
  },
  '首页': {
    '注册': 'Register',
    '影片': 'Video',
    '女团': 'Girls',
    '热门城市': 'Hot Cities:',
    '经理预订': 'Manager Booking',
    '看更多': 'More',
    '身份验证': 'Verified',
    '身高': 'Height',
    '胸围': 'Bust',
    '服务城市': 'City:',
  },
  '女团': {
    '女团': 'Girls',
    '选妃': 'Choose',
    '身份验证': 'Verified',
    '身高': 'Height',
    '胸围': 'Bust',
    '服务城市': 'City:',
    '注册': 'Register',
    '请联系顾问或接待员': 'Please contact advisor',
  },
  '登录': {
    '登录会员视窗': 'Member Login',
    '请输入用户名': 'Username',
    '请输入密码': 'Password',
    '登录': 'Login',
    '没有账号马上注册': 'No account? Register',
    '登录成功': 'Login successful',
    '登录注册': 'Login / Register',
    '登录可享受更多服务': 'Login for more services!',
  },
  '注册': {
    '注册': 'Register',
    '登录': 'Login',
    '请输入用户名': 'Username',
    '用户名规则': '6-20 letters/numbers',
    '请输入密码': 'Password',
    '密码规则': '6-16 letters and numbers',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Enter 4-digit captcha',
    '请输入邀请码': 'Invite code',
    '邀请码规则': 'Enter agent invite code',
    '同意协议': 'I am 18+ and agree to the Terms',
    '立即注册': 'Register Now',
    '注册中': 'Registering...',
    '已有账号马上登录': 'Have an account? Login',
    '注册成功': 'Registered!',
    '注册失败': 'Register failed: ',
    '验证码错误': 'Invalid captcha',
    '请同意注册条款': 'Please agree to the terms',
    '用户名已存在': 'Username exists',
    '邀请码无效': 'Invalid invite code',
  },
  '抢单': {
    '今日收益': "Today's Income",
    '余额': 'Balance',
    '订单': 'Orders',
    '开始抢单': 'Start Grab',
    '当前等级': 'Level:',
    '提现': 'Withdraw',
    '在线客服': 'Support',
    '充值': 'Recharge',
    '幸运任务': 'Lucky Task',
    '幸运订单': 'Lucky Order',
    '幸运订单提示': 'Congrats! This is a high-commission lucky order',
    '恭喜获得幸运订单': 'Lucky order unlocked!',
    '提交订单': 'Submit Order',
    '未完成订单提示': 'You have an unpaid order. Please pay first.',
    '正在获取订单': 'Loading order...',
    '抢单时间': 'Grab Time:',
    '订单号': 'Order No.',
    '订单总额': 'Total',
    '佣金': 'Commission',
    '商品单价': 'Price',
    '预计收入': 'Est. Earnings',
    '确认支付': 'Pay Now',
    '确认付款': 'Confirm Pay',
    '支付处理中': 'Processing...',
    '取消': 'Cancel',
    '去查看': 'View',
    '暂无可用订单': 'No available orders',
    '正在加载用户信息': 'Loading user info...',
    '今日抢单已达上限': 'Daily grab limit reached',
    '余额不足无法获取订单': 'Insufficient balance',
    '获取订单失败': 'Failed to get order',
    '支付成功': 'Payment successful',
    '支付失败': 'Payment failed',
    '支付失败请重试': 'Payment failed, please retry',
    '请完成任务单后进入': 'Complete tasks first',
    '请设置收款卡': 'Please bind a payout address',,
    '当前余额': 'Current Balance',
    '还需缴纳': 'Amount Due',
  },
  '我的': {
    '我的页面': 'My Page',
    '钻石': 'Diamond',
    '信誉分': 'Credit',
    '开通专属会员': 'Open VIP',
    '开启一次日期不限': 'One-time unlock, no date limit',
    '提现': 'Withdraw',
    '历史订单': 'Order History',
    '充值记录': 'Recharge Records',
    '提现记录': 'Withdraw Records',
    '添加钱包地址': 'Add Wallet Address',
    '邀请码': 'Invite Code:',
    '余额': 'Balance',
    '退出登陆': 'Log Out',
  },
  '会员': {
    '会员等级': 'Membership:',
    '普通等级': 'Normal',
    '当前等级': 'Current',
    '立即开通': 'Activate',
    '免费说明': '(Free videos) (Free match)',
    '所需投资': 'Required',
    '佣金': 'Commission',
    '订单': 'Orders',
    '加入': 'Join >>',
  },
  '充值': {
    '充值': 'Recharge',
    '当前余额': 'Balance',
    '余额': 'Balance: ',
    '个': '',
    '充值金额': 'Amount',
    '请输入充值金额': 'Enter amount',
    '快速选择金额': 'Quick Amount',
    '确认': 'Confirm',
    '提示': 'Tips',
    '金额错误': 'Invalid amount',
    '立即充值': 'Recharge Now',
    '提交成功': 'Submitted, pending review',
  },
  '提现': {
    '提现': 'Withdraw',
    '兑换积分': 'Withdraw Points',
    '最大提款金额': 'Max amount',
    '资金密码': 'Fund password',
    '余额': 'Balance: ',
    '个': '',
    '钱包地址': 'Wallet Address: ',
    '请选择提款地址': 'Select withdraw address',
    '暂无绑定地址': 'No address bound yet',
    '提交': 'Submit',
    '通知': 'Notice:',
    '单笔最大提现': '1. Max per withdrawal: ',
    '单笔最低提现': '2. Min per withdrawal: ',
    '检查姓名账号': '3. Check your name and account',
    '注意提款费用': '4. Mind withdrawal fees',
    '请填写正确的金额': 'Enter a valid amount',
    '当前余额': 'Balance',
    '提现金额': 'Amount',
    '请输入提现数量': 'Enter amount',
    '立即提现': 'Withdraw Now',
    '交易密码': 'Pay Password',
    '请输入交易密码': 'Enter pay password',
    '请先设置提现密码': 'Please set withdraw password first',
  },
  '绑卡': {
    '添加钱包地址': 'Add Wallet Address',
    '钱包地址信息': 'Wallet Address',
    '请输入支付卡信息': 'Enter your wallet address',
    '加密货币类型': 'Crypto Type',
    '请选择加密货币类型': 'Select crypto type',
    '钱包地址': 'Wallet Address',
    '请输入钱包地址': 'Enter wallet address',
    '绑卡说明': 'Dear user, for fund safety please bind your real name and set a withdraw password. Name must match your account.',
    '确定绑卡': 'Confirm Bind',
    '绑卡提示': 'Tip: bind a major bank. Contact support to modify.',
    '请先设置姓名': 'Please set your name before binding!',
    '已绑定不可修改': 'Address already bound. Contact support to change.',
  },
  '订单历史': {
    '订单历史': 'Order History',
    '数据为空': 'No Data',
    '订单号': 'Order No.: ',
    '已完成': 'Completed',
    '处理中': 'Processing',
    '完成订单': 'Complete Order',
    '订单金额': 'Amount: ',
    '佣金': 'Commission: ',
    '创建时间': 'Created: ',
    '上一页': 'Prev',
    '下一页': 'Next',
    '获取失败': 'Failed to load history',
    '获取失败重试': 'Failed to load, please retry',
    '未知': 'Unknown',
    '完成成功': 'Order completed!',
    '完成失败': 'Complete failed: ',
    '完成失败重试': 'Complete failed, please retry',
    '请输入支付密码': 'Enter payment password',
    '请先设置支付密码': 'Please set payment password first',
  },
  '入金记录': {
    '标题': 'Recharge Records',
    '数据为空': 'No Data',
    '认证结果': 'Result',
    '下单积分': 'Points: ',
    '下单时间': 'Ordered: ',
    '结算时间': 'Settled: ',
    '待审核': 'Pending',
    '已通过': 'Approved',
    '已拒绝': 'Rejected',
    '暂无数据': 'No Data',
  },
  '提现记录': {
    '标题': 'Withdraw Records',
    '数据为空': 'No Data',
    '待审核': 'Pending',
    '审核成功': 'Approved',
    '审核退回': 'Rejected',
    '未知状态': 'Unknown',
    '金额': 'Amount: ',
    '说明': 'Note: ',
    '提交时间': 'Submitted: ',
    '审核时间': 'Reviewed: ',
    '已通过': 'Approved',
    '已拒绝': 'Rejected',
    '暂无数据': 'No Data',
  },
  '资料': {
    '基本信息': 'Profile',
    '头像': 'Avatar',
    '姓名': 'Name',
    '未设置': 'Not set',
    '性别': 'Gender',
    '男': 'Male',
    '女': 'Female',
    '未知': 'Unknown',
    '设定': 'Settings',
    '账号信息': 'Account',
    '更改登录密码': 'Change Login Password',
    '设定支付密码': 'Set Pay Password',
    '退出登录': 'Log Out',
    '设置': 'Settings',
    '登录密码': 'Login Password',
    '资金密码': 'Fund Password',
    '提现密码已设置': 'Pay password set. Contact support to change.',
    '已设置': 'Set',
    '修改真实姓名': 'Edit Real Name',
    '请输入真实姓名': 'Enter real name',
    '真实姓名说明': 'Real name must match your wallet information',
    '提交': 'Submit',
    '请勿重复设置': 'Already set!',
    '修改登录密码': 'Change Login Password',
    '设置资金密码': 'Set Fund Password',
    '保存': 'Save',
    '旧密码': 'Old Password',
    '请输入旧密码': 'Enter old password',
    '新密码': 'New Password',
    '请输入新密码': 'Enter new password',
    '确认密码': 'Confirm Password',
    '请再次输入新密码': 'Enter new password again',
    '请填写完整': 'Please fill in all fields!',
    '两次密码不一致': 'Passwords do not match',
    '性别修改': 'Edit Gender',
    '个人报表': 'Personal Report',
    '任务金额积分': 'Task Amount (Points)',
    '盈利公式': 'Profit = Win - Task Amount',
    '任务金额': 'Task Amount',
    '充值金额': 'Recharge',
    '金额': 'Amount',
    '中奖金额': 'Win Amount',
    '个人情报': 'Profile',
    '身高': 'Height:',
    '胸围': 'Bust:',
    '收费区间': 'Price Range:',
    '系统公告': 'Announcements',
  },
  '客服': {
    '联系客服': 'Contact Support',
    '在线客服': 'Online Support',
    '暂无客服': 'No support available',
    '联系': 'Contact',
    '服务时间': '24/7 at your service',
  },
  '影院': {
    '影院': 'Cinema',
    '全部': 'All',
    '最高分': 'Top Rated',
    '播放': 'Plays: ',
    '次播放': ' plays',
    '热门推荐': 'Hot',
    '播放次数': 'Plays:',
    '请充值后观看': 'Please recharge to watch',
  },
  '语言切换器': {
    '切换语言': 'Language',
    '语言': 'Language',
  },
}
